type NamedModel = { upstreamModelId: string };

export function modelKind(model: NamedModel): 'text' | 'image' | 'video' | 'music' | 'voice' {
  const id = model.upstreamModelId.toLowerCase();
  if (/(?:^|[-_])tts(?:$|[-_])|speech|audio/.test(id)) return 'voice';
  if (id.includes('video')) return 'video';
  if (id.includes('image')) return 'image';
  if (id.includes('music')) return 'music';
  return 'text';
}

export const isTextModel = (model: NamedModel) => modelKind(model) === 'text';
export const isVoiceModel = (model: NamedModel) => modelKind(model) === 'voice';

/** Official preset IDs; only eve/rex have passed this deployment's Chinese check. */
export const speechVoices = [
  'eve',
  'rex',
  'carina',
  'zagan',
  'helix',
  'orion',
  'luna',
  'iris',
  'altair',
  'zenith',
  'perseus',
  'helios',
  'lux',
  'kepler',
  'rigel',
  'cosmo',
  'celeste',
  'ursa',
  'sirius',
  'lumen',
  'castor',
  'naksh',
  'atlas',
  'aurora',
  'liora',
  'ara',
  'leo',
  'sal',
].map((id) => ({
  id,
  label: `${id} · ${['eve', 'rex'].includes(id) ? '中文已实测' : '官方预设，待试听'}`,
}));
